import { getRandomScheduleId } from 'routes/Studies/routes/Study/routes/Instruments/utils/getRandomScheduleId'
import { mapAvailabilityToApi } from '../adapters/legacySchedulePayload'
import { createEmptyAvailability } from '../models/createEmptyAvailability'
import { TIMING_MODE } from './timingMode'
import { COHORT_TYPE } from './audienceTypes'

/**
 * Default metadata.schedule[] item when scheduling_engine is on.
 * Uses the existing V2 schedule wrapper with deploy.anchors[] (Examples A/B/C).
 */
export const getDefaultScheduleV3 = () => ({
  schedule_id: getRandomScheduleId(),
  version: 1,
  platform_type: 'all',
  audience_type: 'all_participants',
  availability: mapAvailabilityToApi(createEmptyAvailability()),
  cohort: [{ type: COHORT_TYPE.allParticipants, filter: {} }],
  deploy: {
    combine: 'none',
    anchors: [
      {
        type: 'participant_start',
        point: 'start',
        offset: { value: 0, unit: 'days', direction: 'after' },
        timing_mode: TIMING_MODE.fromStartOfDay,
      },
    ],
  },
})

export const isV3ScheduleShape = schedule => {
  const first = Array.isArray(schedule) ? schedule[0] : schedule
  return Array.isArray(first?.deploy?.anchors)
}

/** Ensure create/update metadata uses a schedule array with deploy.anchors[]. */
export const applyDefaultV3Schedule = (metadata = {}) => {
  const next = { ...metadata }
  if (isV3ScheduleShape(next.schedule)) {
    next.schedule = Array.isArray(next.schedule) ? next.schedule : [next.schedule]
  } else {
    next.schedule = [getDefaultScheduleV3()]
  }
  delete next.visibility
  delete next.visibilityRanges
  return next
}
